import type { ComponentProps } from "react";

import CustomSnackbar from "layouts/common-components/CustomSnackbar";

import { useNotify, useNotifState } from "context/app/NotifyContext";

type SnackbarColor = NonNullable<ComponentProps<typeof CustomSnackbar>["color"]>;

// notifObj.type is set by FetchRequest ("error" / "success") and by a few pages.
// Everything unknown stays neutral.
const NOTIF_COLORS: Partial<Record<string, SnackbarColor>> = {
  error: "error",
  success: "success",
  warning: "warning",
  info: "info",
};

// A toast must never come up blank again, even when a caller forgets the text.
const NOTIF_FALLBACK_TEXT: Partial<Record<string, string>> = {
  error: "Request failed. Open the console for the details.",
  success: "Done",
};

// This component is the only subscriber to the notification state. It used to be
// inlined in App, which meant every toast re-rendered the whole routed tree.
function AppNotification() {
  const notifObj = useNotifState();
  const { hideNotif } = useNotify();

  return (
    <div className="notif-wrap">
      <CustomSnackbar
        color={NOTIF_COLORS[notifObj.type] || "info"}
        icon="notifications"
        title="EfficientSoftware"
        content={notifObj.text || NOTIF_FALLBACK_TEXT[notifObj.type] || ""}
        open={notifObj.show === true}
        close={hideNotif}
        pre={true}
        copyOption={true}
      />
    </div>
  );
}

export default AppNotification;
